import { render, staticRenderFns } from "./LandingCreatorsFooter.vue?vue&type=template&id=0d5603b0&"
import script from "./LandingCreatorsFooter.vue?vue&type=script&lang=ts&"
export * from "./LandingCreatorsFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports